import { Box, MenuItem } from "@mui/material";
import { FC } from "react";
import { PaperHeader, Price, Select, Table } from "ui";
import { IFormContext } from "ui/Form/FormContext";

type TGastroPayCommissions = {
    context: IFormContext;
    errors: string[];
    commissionsId: string;
};

const GastroPayCommissions: FC<TGastroPayCommissions> = ({
    context,
    errors,
    commissionsId,
}) => {
    // const handleAddCommission = () => {
    //     context.onChange({
    //         id: commissionsId,
    //         value: [
    //             ...context.data[commissionsId],
    //             {
    //                 product_platform: "consumer",
    //                 payment_product_type: "bambora.applepay",
    //                 domestic_percentage: 165,
    //                 domestic_fixed: 100,
    //                 eea_percentage: 165,
    //                 eea_fixed: 100,
    //                 eea_uk_percentage: 495,
    //                 eea_uk_fixed: 200,
    //                 europe_percentage: 495,
    //                 europe_fixed: 200,
    //                 inter_percentage: 495,
    //                 inter_fixed: 200,
    //             },
    //         ],
    //     });
    // };

    return (
        <Box sx={{ mt: 2 }}>
            <PaperHeader
                // actions={
                //     <IconButton onClick={handleAddCommission}>
                //         <Icon>add</Icon>
                //     </IconButton>
                // }
                sx={{ mt: 2 }}
                title="Commissions"
            />
            {errors && errors.length > 0 && (
                <Box sx={{ mb: 2 }}>
                    {errors.map((error, index) => (
                        <Box key={index} color="error.main">
                            {error}
                        </Box>
                    ))}
                </Box>
            )}
            <Table
                id="gastro-pay-commissions-table"
                columns={[
                    {
                        field: "product_platform",
                        headName: "Platform",
                        renderCell: (item, key, idx) => ({
                            children: (
                                <Select
                                    id={`${commissionsId}.${idx}.product_platform`}
                                    sx={{ width: "150px" }}
                                    disabled={idx < 3} // Disable first 3 rows
                                >
                                    <MenuItem value="consumer">
                                        Consumer
                                    </MenuItem>
                                    <MenuItem value="commercial">
                                        Commercial
                                    </MenuItem>
                                </Select>
                            ),
                        }),
                    },
                    {
                        field: "payment_product_type",
                        headName: "Product Type",
                        renderCell: (item, key, idx) => {
                            if (item.payment_product_type === null) {
                                return {
                                    children: "All",
                                };
                            }

                            return {
                                children: (
                                    <Select
                                        id={`${commissionsId}.${idx}.payment_product_type`}
                                        sx={{ width: "150px" }}
                                        disabled={idx < 3} // Disable first 3 rows
                                    >
                                        <MenuItem value="bambora.applepay">
                                            bambora.applepay
                                        </MenuItem>
                                        <MenuItem value="bambora.creditcard">
                                            bambora.creditcard
                                        </MenuItem>
                                        <MenuItem value="bambora.googlepay">
                                            bambora.googlepay
                                        </MenuItem>
                                        <MenuItem value="bambora.vipps">
                                            bambora.vipps
                                        </MenuItem>
                                        <MenuItem value="klarna.klarna">
                                            klarna.klarna
                                        </MenuItem>
                                    </Select>
                                ),
                            };
                        },
                    },
                    {
                        field: "domestic_percentage",
                        headName: "Domestic %",
                        renderCell(item, key, idx) {
                            return {
                                children: (
                                    <Price
                                        id={`${commissionsId}.${idx}.domestic_percentage`}
                                        sx={{ width: "75px" }}
                                    />
                                ),
                                sx: { backgroundColor: "#88E788" },
                            };
                        },
                    },
                    {
                        field: "domestic_fixed",
                        headName: "Domestic Fixed",
                        renderCell(item, key, idx) {
                            return {
                                children: (
                                    <Price
                                        id={`${commissionsId}.${idx}.domestic_fixed`}
                                        sx={{ width: "75px" }}
                                    />
                                ),
                                sx: { backgroundColor: "#88E788" },
                            };
                        },
                    },
                    {
                        field: "eea_percentage",
                        headName: "EEA %",
                        renderCell(item, key, idx) {
                            return {
                                children: (
                                    <Price
                                        id={`${commissionsId}.${idx}.eea_percentage`}
                                        sx={{ width: "75px" }}
                                    />
                                ),
                                sx: {
                                    backgroundColor: "#88E788",
                                    borderLeft: "1px solid #ccc",
                                },
                            };
                        },
                    },
                    {
                        field: "eea_fixed",
                        headName: "EEA Fixed",
                        renderCell(item, key, idx) {
                            return {
                                children: (
                                    <Price
                                        id={`${commissionsId}.${idx}.eea_fixed`}
                                        sx={{ width: "75px" }}
                                    />
                                ),
                                sx: { backgroundColor: "#88E788" },
                            };
                        },
                    },
                    {
                        field: "eea_uk_percentage",
                        headName: "EEA UK %",
                        renderCell(item, key, idx) {
                            return {
                                children: (
                                    <Price
                                        id={`${commissionsId}.${idx}.eea_uk_percentage`}
                                        sx={{ width: "75px" }}
                                    />
                                ),
                                sx: {
                                    backgroundColor: "#FFB3B3",
                                    borderLeft: "1px solid #ccc",
                                },
                            };
                        },
                    },
                    {
                        field: "eea_uk_fixed",
                        headName: "EEA UK Fixed",
                        renderCell(item, key, idx) {
                            return {
                                children: (
                                    <Price
                                        id={`${commissionsId}.${idx}.eea_uk_fixed`}
                                        sx={{ width: "75px" }}
                                    />
                                ),
                                sx: { backgroundColor: "#FFB3B3" },
                            };
                        },
                    },
                    {
                        field: "europe_percentage",
                        headName: "Europe %",
                        renderCell(item, key, idx) {
                            return {
                                children: (
                                    <Price
                                        id={`${commissionsId}.${idx}.europe_percentage`}
                                        sx={{ width: "75px" }}
                                    />
                                ),
                                sx: {
                                    backgroundColor: "#FFB3B3",
                                    borderLeft: "1px solid #ccc",
                                },
                            };
                        },
                    },
                    {
                        field: "europe_fixed",
                        headName: "Europe Fixed",
                        renderCell(item, key, idx) {
                            return {
                                children: (
                                    <Price
                                        id={`${commissionsId}.${idx}.europe_fixed`}
                                        sx={{ width: "75px" }}
                                    />
                                ),
                                sx: { backgroundColor: "#FFB3B3" },
                            };
                        },
                    },
                    {
                        field: "inter_percentage",
                        headName: "Inter %",
                        renderCell(item, key, idx) {
                            return {
                                children: (
                                    <Price
                                        id={`${commissionsId}.${idx}.inter_percentage`}
                                        sx={{ width: "75px" }}
                                    />
                                ),
                                sx: {
                                    backgroundColor: "#FFB3B3",
                                    borderLeft: "1px solid #ccc",
                                },
                            };
                        },
                    },
                    {
                        field: "inter_fixed",
                        headName: "Inter Fixed",
                        renderCell(item, key, idx) {
                            return {
                                children: (
                                    <Price
                                        id={`${commissionsId}.${idx}.inter_fixed`}
                                        sx={{ width: "100px" }}
                                    />
                                ),
                                sx: {
                                    backgroundColor: "#FFB3B3",
                                },
                            };
                        },
                    },
                ]}
                rows={context.data[commissionsId] || []}
            />
        </Box>
    );
};

export default GastroPayCommissions;
